import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { Lock, ArrowRight } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center bg-[#0A0A0C] text-white">
      <div className="max-w-md mx-auto w-full px-6">
        <Link to="/" className="text-xs tracking-[0.3em] uppercase text-white/40 hover:text-white">
          ← Back to site
        </Link>
        <div className="mt-10 border border-white/10 bg-[#121215] p-10">
          <div className="flex items-center gap-3 mb-8">
            <Lock size={18} className="text-[#E85D04]" />
            <div className="text-xs tracking-[0.3em] uppercase text-[#E85D04]">Admin Access</div>
          </div>
          <h1 className="font-serif-display text-4xl">Sign in.</h1>
          <form onSubmit={submit} className="mt-10 space-y-5">
            <label className="block">
              <span className="block text-[10px] tracking-[0.3em] uppercase text-white/50 mb-2">Email</span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-login-email"
                autoComplete="email"
                className="w-full bg-[#0A0A0C] border border-white/10 px-4 py-3 outline-none focus:border-[#E85D04]"
              />
            </label>
            <label className="block">
              <span className="block text-[10px] tracking-[0.3em] uppercase text-white/50 mb-2">Password</span>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-login-password"
                autoComplete="current-password"
                className="w-full bg-[#0A0A0C] border border-white/10 px-4 py-3 outline-none focus:border-[#E85D04]"
              />
            </label>
            {error && <div data-testid="admin-login-error" className="text-red-400 text-sm">{error}</div>}
            <button
              type="submit"
              disabled={submitting}
              data-testid="admin-login-submit"
              className="w-full inline-flex items-center justify-center gap-3 bg-[#E85D04] hover:bg-[#DC2F02] text-white px-8 py-4 text-xs tracking-[0.22em] uppercase disabled:opacity-60"
            >
              {submitting ? "Authenticating…" : "Sign In"} <ArrowRight size={14} />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
